import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import Spinner from "@atlaskit/spinner";

export const FormLoading = ({
    notFullHeight = false
}: {
    notFullHeight?: boolean;
}) => {
    const intl = useIntl();
    const loading = intl.formatMessage({
        id: "BxpUiSignup.SignupForm.loading",
        defaultMessage: "Loading"
    });

    return (
        <div
            css={[formLoadingCss, !notFullHeight && formLoadingFullHeightCss]}
            role="progressbar"
            aria-label={loading}
        >
            <Spinner size="large" />
        </div>
    );
};

const formLoadingCss = css({
    alignItems: "center",
    display: "flex",
    justifyContent: "center"
});

const formLoadingFullHeightCss = css({
    height: "100vh"
});
